<template>
  <div class="user-container">
    <el-dialog :title="operateType === 'add' ? '新增用户' : '编辑用户'" :visible.sync="dialogFormVisible" width="40%">
      <el-form :model="formData" ref="userForm" :rules="rules" :inline="inline" status-icon style="width: 500px; margin-left: 50px" label-width="80px" label-position="">
        <el-form-item label="用户名" prop="username">
          <el-input v-model.trim="formData.username" :disabled="statusType" :readonly="readonly" size="small" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item v-if="operateType === 'add'" label="密码" prop="password">
          <el-input v-model.trim="formData.password" type="password" size="small" autocomplete="off" show-password placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model.trim="formData.email" :disabled="statusType" size="small" placeholder="请输入邮箱" />
        </el-form-item>

        <!-- <el-form-item label="角色" prop="role">
          <el-select v-model="formData.role" size="small" placeholder="请选择">
            <el-option label="管理员" value="admin"> </el-option>
            <el-option label="操作员" value="operator"> </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="角色" prop="role">
          <treeselect v-model="formData.role" :multiple="true" :clearable="false" :normalizer="normalizer" :options="roleOptions" @input="roleValidate" placeholder="请选择角色" />
        </el-form-item>

        <el-form-item label="状态" size="small" prop="state">
          <el-switch v-model="formData.state" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="resetForm">取 消</el-button>
          <el-button size="small" type="primary" @click="submitForm('userForm')">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <div class="filter-container">
      <el-input
        v-perm="['/sys/user/view']"
        placeholder="用户名过滤"
        prefix-icon="el-icon-search"
        size="small"
        v-model="filters[0].value"
        style="width: 200px;margin-right: 10px"
        class="filter-item"
      />
      <el-select v-perm="['/sys/user/view']" clearable class="filter-item" size="small" placeholder="状态过滤" v-model="filters[1].value">
        <el-option label="正常" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-button v-perm="['/sys/user/add']" class="filter-item" style="margin-left: 10px;" size="mini" type="primary" icon="el-icon-plus" @click="handleUserAdd">添加</el-button>
    </div>
    <data-tables-server
      :data="data"
      :total="total"
      :filters="filters"
      :table-props="tableProps"
      :loading="loading"
      :page-size="5"
      :pagination-props="{ background: true, pageSizes: [5, 10, 20] }"
      layout="table,pagination"
      @query-change="fetchData"
    >
      <!-- <el-table-column type="selection" width="50"> </el-table-column> -->

      <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom" />
      <el-table-column label="用户状态" align="center" min-width="100px" prop="state">
        <template slot-scope="scope">
          <el-tag :type="scope.row.state | stateFilter(scope.row.state)" size="small">{{ scope.row.state | stateShowFilter(scope.row.state) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="是否在线" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | onlineFilter(scope.row.status)" size="small">{{ scope.row.status | onlineShowFilter(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="100px">
        <template slot-scope="scope">
          <el-button v-perm="['/sys/user/edit']" :size="btnsize" type="success" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button v-perm="['/sys/user/del']" :size="btnsize" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </data-tables-server>
  </div>
</template>

<script>
import Vue from "vue"
import { DataTablesServer } from "vue-data-tables"
Vue.use(DataTablesServer)

//import perm权限
import perm from "@/directive/permission/index.js" // 权限判断指令

// import the component
import Treeselect from "@riophae/vue-treeselect"
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css"
//import { createUser, updateUser, deleteUser, getUserList, getRoleOptions } from "@/api/user"
import { createUser, updateUser, deleteUser, getRoleOptions, getUserList } from "@/api/user"

export default {
  components: { Treeselect },
  directives: { perm },
  name: "User",
  filters: {
    stateFilter(status) {
      const stateMap = {
        true: "success",
        false: "danger"
      }
      return stateMap[status]
    },
    stateShowFilter(status) {
      const stateShowMap = {
        true: "正常",
        false: "禁用"
      }
      return stateShowMap[status]
    },
    onlineFilter(status) {
      const onlineMap = {
        true: "success",
        false: "danger"
      }
      return onlineMap[status]
    },
    onlineShowFilter(status) {
      const onlineShowMap = {
        true: "在线",
        false: "离线"
      }
      return onlineShowMap[status]
    }
  },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback("密码不能为空")
      }
      if (value.length < 6) {
        callback(new Error("密码要6位以上"))
      } else {
        callback()
      }
    }
    return {
      roleOptions: [],
      //自定义id,label
      normalizer(node) {
        return {
          id: node.rid,
          label: node.role_name
          //children: node.children
        }
      },
      defaultQueryInfo: "",
      currentPage: 1,
      inline: false,
      readonly: false,
      dialogFormVisible: false,
      operateType: "add",
      statusType: false,
      formData: {
        username: "",
        password: "",
        email: "",
        role: [],
        state: true
      },
      rules: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, trigger: "blur", validator: validatePassword }],
        role: [{ required: true, message: "请选择角色", trigger: "input" }]
      },
      data: [],
      titles: [
        {
          prop: "uid",
          label: "ID"
        },
        {
          prop: "username",
          label: "用户名"
        },
        {
          prop: "email",
          label: "Email"
        }
      ],
      btnsize: "mini",
      tableProps: {
        border: true,
        stripe: true,
        highlightCurrentRow: true,
        defaultSort: {
          prop: "uid",
          order: "ascending"
        }
      },
      loading: false,
      total: 1,
      //过滤发生在后台
      filters: [
        {
          prop: "username",
          value: ""
        },
        {
          //状态:启用/禁用
          prop: "state",
          value: ""
        }
      ]
    }
  },
  created() {
    this.initRoleOptions()
  },
  methods: {
    roleValidate() {
      this.$refs.userForm.clearValidate()
    },
    resetformData() {
      this.formData = {
        username: "",
        password: "",
        email: "",
        role: [],
        state: true
      }
    },
    initRoleOptions() {
      getRoleOptions().then(res => {
        this.roleOptions = res.data
      })
    },
    handleUserAdd() {
      //reset formData
      //console.log("i am here")
      //清除上一次add或者update的数据
      this.dialogFormVisible = true
      this.resetformData()
      this.operateType = "add"
      this.statusType = false
      //这时候dom还没有更新完成，因为这些代码都是在主线程中执行的，而vue中设计的dom更新发生在异步队列
      //this.$refs.userForm.clearValidate()
      this.$nextTick(() => {
        //这里的回调函数在dom更新后调用
        //清除上一次的验证规则
        this.$refs.userForm.clearValidate()
      })
    },
    handleUpdate(rowdata) {
      this.operateType = "edit"
      this.statusType = true
      this.dialogFormVisible = true
      this.formData = Object.assign({}, rowdata)
      //console.log(rowdata)
      //this.$refs.userForm.clearValidate()
      this.$nextTick(() => {
        //清除在add的时候的验证规则
        this.$refs.userForm.clearValidate()
      })
    },
    handleDelete(rowdata) {
      this.$confirm("此操作将永久删除用户 : [" + rowdata.username + "] ， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          //json传到php转为关联数组
          const tempData = {
            uid: rowdata.uid,
            username: rowdata.username
          }
          deleteUser(tempData).then(res => {
            if (res.type === "success") {
              this.fetchData()
            }
            this.$notify({
              message: res.message,
              type: res.type
            })
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          })
        })
    },
    //每次过滤，排序都会触发这个函数调用
    fetchData(queryInfo) {
      //console.log("gaga:" + queryInfo.type)
      if (!queryInfo) {
        queryInfo = this.defaultQueryInfo
      }
      if (queryInfo.type === "init") {
        this.defaultQueryInfo = queryInfo
      }
      //this.currentPage = queryInfo.page
      //console.log(this.currentPage, queryInfo.page)
      //;(queryInfo.type === "page" || queryInfo.type === "size") && this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}`)
      this.loading = true
      //console.log(queryInfo)
      getUserList(queryInfo).then(res => {
        this.data = res.data.items
        this.total = res.data.total
        this.loading = false
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.operateType === "add") {
            createUser(this.formData).then(res => {
              this.fetchData()
              this.dialogFormVisible = false
              this.$notify({
                type: res.type,
                message: res.message
              })
            })
          } else if (this.operateType === "edit") {
            updateUser(this.formData).then(res => {
              this.fetchData()
              this.dialogFormVisible = false
              this.$notify({
                type: res.type,
                message: res.message
              })
            })
          }
        } else {
          return false
        }
      })
    },
    resetForm() {
      //this.$refs[formName].resetFields()
      this.dialogFormVisible = false
    }
  }
}
</script>

<style lang="scss">
.user-container {
  margin-top: 30px;
  .filter-container {
    margin-bottom: 30px;
  }
}
.pagination-wrap {
  margin-top: 10px;
  text-align: center;
}
</style>
